export const appConfig = {
	HELP_CENTER_URL: "https://parkersupport.joinoffstreet.com",
};
